import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type FeatureFlagFieldsFragment = { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean };

export type GetFeatureFlagQueryVariables = Types.Exact<{
  name: Types.FeatureFlagName;
}>;


export type GetFeatureFlagQuery = { __typename?: 'Query', featureFlag: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean } };

export type GetAllFeatureFlagsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAllFeatureFlagsQuery = { __typename?: 'Query', ACTIVITY_CENTER: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, AI_CHAT: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, AVAILABILITY_APP: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, COST_ACCOUNTING: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, COUNT_APP: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, CUSTOMER_PORTAL: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, DATA_TRANSFORM: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, EDI: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, ENGAGE: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, ENGAGE_RFID: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, EVENTS_APP: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, FORECAST: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, FLAT_CHARGES: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, FULFILL_DASHBOARD: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, FULFILL_KITS: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, FULFILL_LOGISTICS: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, HOME_DASHBOARD: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, INLINE_INVENTORY_EDIT: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, INTELLIGENCE: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, JEV_DECISIONS: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, LEARNING_PATH: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, MATERIAL_APP: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, NOTIFICATIONS: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, ORDER_CORRECTION: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, PERSONALIZED_PRICING_PAGE: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, PRODUCE: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, PRODUCE_PLAN_BUILDER: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, PRODUCED_LOT_FULFILL_INVENTORY: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, PURCHASING_PO_WORKSPACE: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, REAPPLY_RECIPES: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, RESTOCK: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, ROYALTY_ENABLED: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, SCHEDULED_ITEM_TRANSFERS: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, SMS_NOTIFICATIONS: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, STORE_CLASSES: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, TAGS: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, USE_ERP_AVAILABILITY: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, VERIFY: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, WHATS_NEW: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, PRODUCE_CONSOLIDATION: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, BENCHMARK: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean }, PRODUCTION_CENTER: { __typename?: 'FeatureFlagValueResult', config: string, enabled: boolean } };

export const FeatureFlagFieldsFragmentDoc = new TypedDocumentString(`
    fragment FeatureFlagFields on FeatureFlagValueResult {
  config
  enabled
}
    `, {"fragmentName":"FeatureFlagFields"});
export const GetFeatureFlagDocument = new TypedDocumentString(`
    query GetFeatureFlag($name: FeatureFlagName!) {
  featureFlag(name: $name) {
    ...FeatureFlagFields
  }
}
    fragment FeatureFlagFields on FeatureFlagValueResult {
  config
  enabled
}`);
export const GetAllFeatureFlagsDocument = new TypedDocumentString(`
    query GetAllFeatureFlags {
  ACTIVITY_CENTER: featureFlag(name: ACTIVITY_CENTER) {
    ...FeatureFlagFields
  }
  AI_CHAT: featureFlag(name: AI_CHAT) {
    ...FeatureFlagFields
  }
  AVAILABILITY_APP: featureFlag(name: AVAILABILITY_APP) {
    ...FeatureFlagFields
  }
  COST_ACCOUNTING: featureFlag(name: COST_ACCOUNTING) {
    ...FeatureFlagFields
  }
  COUNT_APP: featureFlag(name: COUNT_APP) {
    ...FeatureFlagFields
  }
  CUSTOMER_PORTAL: featureFlag(name: CUSTOMER_PORTAL) {
    ...FeatureFlagFields
  }
  DATA_TRANSFORM: featureFlag(name: DATA_TRANSFORM) {
    ...FeatureFlagFields
  }
  EDI: featureFlag(name: EDI) {
    ...FeatureFlagFields
  }
  ENGAGE: featureFlag(name: ENGAGE) {
    ...FeatureFlagFields
  }
  ENGAGE_RFID: featureFlag(name: ENGAGE_RFID) {
    ...FeatureFlagFields
  }
  EVENTS_APP: featureFlag(name: EVENTS_APP) {
    ...FeatureFlagFields
  }
  FORECAST: featureFlag(name: FORECAST) {
    ...FeatureFlagFields
  }
  FLAT_CHARGES: featureFlag(name: FLAT_CHARGES) {
    ...FeatureFlagFields
  }
  FULFILL_DASHBOARD: featureFlag(name: FULFILL_DASHBOARD) {
    ...FeatureFlagFields
  }
  FULFILL_KITS: featureFlag(name: FULFILL_KITS) {
    ...FeatureFlagFields
  }
  FULFILL_LOGISTICS: featureFlag(name: FULFILL_LOGISTICS) {
    ...FeatureFlagFields
  }
  HOME_DASHBOARD: featureFlag(name: HOME_DASHBOARD) {
    ...FeatureFlagFields
  }
  INLINE_INVENTORY_EDIT: featureFlag(name: INLINE_INVENTORY_EDIT) {
    ...FeatureFlagFields
  }
  INTELLIGENCE: featureFlag(name: INTELLIGENCE) {
    ...FeatureFlagFields
  }
  JEV_DECISIONS: featureFlag(name: JEV_DECISIONS) {
    ...FeatureFlagFields
  }
  LEARNING_PATH: featureFlag(name: LEARNING_PATH) {
    ...FeatureFlagFields
  }
  MATERIAL_APP: featureFlag(name: MATERIAL_APP) {
    ...FeatureFlagFields
  }
  NOTIFICATIONS: featureFlag(name: NOTIFICATIONS) {
    ...FeatureFlagFields
  }
  ORDER_CORRECTION: featureFlag(name: ORDER_CORRECTION) {
    ...FeatureFlagFields
  }
  PERSONALIZED_PRICING_PAGE: featureFlag(name: PERSONALIZED_PRICING_PAGE) {
    ...FeatureFlagFields
  }
  PRODUCE: featureFlag(name: PRODUCE) {
    ...FeatureFlagFields
  }
  PRODUCE_PLAN_BUILDER: featureFlag(name: PRODUCE_PLAN_BUILDER) {
    ...FeatureFlagFields
  }
  PRODUCED_LOT_FULFILL_INVENTORY: featureFlag(
    name: PRODUCED_LOT_FULFILL_INVENTORY
  ) {
    ...FeatureFlagFields
  }
  PURCHASING_PO_WORKSPACE: featureFlag(name: PURCHASING_PO_WORKSPACE) {
    ...FeatureFlagFields
  }
  REAPPLY_RECIPES: featureFlag(name: REAPPLY_RECIPES) {
    ...FeatureFlagFields
  }
  RESTOCK: featureFlag(name: RESTOCK) {
    ...FeatureFlagFields
  }
  ROYALTY_ENABLED: featureFlag(name: ROYALTY_ENABLED) {
    ...FeatureFlagFields
  }
  SCHEDULED_ITEM_TRANSFERS: featureFlag(name: SCHEDULED_ITEM_TRANSFERS) {
    ...FeatureFlagFields
  }
  SMS_NOTIFICATIONS: featureFlag(name: SMS_NOTIFICATIONS) {
    ...FeatureFlagFields
  }
  STORE_CLASSES: featureFlag(name: STORE_CLASSES) {
    ...FeatureFlagFields
  }
  TAGS: featureFlag(name: TAGS) {
    ...FeatureFlagFields
  }
  USE_ERP_AVAILABILITY: featureFlag(name: USE_ERP_AVAILABILITY) {
    ...FeatureFlagFields
  }
  VERIFY: featureFlag(name: VERIFY) {
    ...FeatureFlagFields
  }
  WHATS_NEW: featureFlag(name: WHATS_NEW) {
    ...FeatureFlagFields
  }
  PRODUCE_CONSOLIDATION: featureFlag(name: PRODUCE_CONSOLIDATION) {
    ...FeatureFlagFields
  }
  BENCHMARK: featureFlag(name: BENCHMARK) {
    ...FeatureFlagFields
  }
  PRODUCTION_CENTER: featureFlag(name: PRODUCTION_CENTER) {
    ...FeatureFlagFields
  }
}
    fragment FeatureFlagFields on FeatureFlagValueResult {
  config
  enabled
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetFeatureFlag: build.query<GetFeatureFlagQuery, GetFeatureFlagQueryVariables>({
      query: (variables) => ({ document: GetFeatureFlagDocument, variables })
    }),
    GetAllFeatureFlags: build.query<GetAllFeatureFlagsQuery, GetAllFeatureFlagsQueryVariables | void>({
      query: (variables) => ({ document: GetAllFeatureFlagsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetFeatureFlagQuery, useLazyGetFeatureFlagQuery, useGetAllFeatureFlagsQuery, useLazyGetAllFeatureFlagsQuery } = injectedRtkApi;
